import { h } from "preact";

import style from './style';
import { Text } from "preact-i18n";

const FourOFour = ({search = 'onbekend'}) => (
  <div>
    <Text id="components.Geen resultaat voor">
      Geen resultaat voor
    </Text> <span class={style['search']}>{search}</span>.
  </div>
);

export default FourOFour;
